import React, { useEffect, useContext } from 'react'
import { Step1EnterPremiumChooseTerm } from '../InputSteps/Step1EnterPremiumChooseTerm/Step1EnterPremiumChooseTerm';

import './CalculatorTool.scss';
import { StepLabel } from '../StepIndicator/Step';
import { CalculatorSteps } from '../../model/CalculatorSteps';
import { CalculatorStepsContext } from '../Store/CalculatorStepsContext';
import { CalculatorStepIndicator } from '../StepIndicator/CalculatorStepIndicator';
import { Step2SelectStrategies } from '../InputSteps/Step2SelectStrategies/Step2SelectStrategies';
import { Step3ChooseBuffers } from '../InputSteps/Step3ChooseBuffers/Step3ChooseBuffers';
import { Step4ChooseIndicesEnterAllocations } from '../InputSteps/Step4ChooseIndicesEnterAllocations/Step4ChooseIndicesEnterAllocations';
import { fetchResources } from './FetchResources';
import { DatePresetsContext } from '../Store/DatePresetsContext';

export const CalculatorTool = () => {
    const stepLabels = [new StepLabel('1'), new StepLabel('2'), new StepLabel('3'), new StepLabel('4')];

    const { steps, setSteps } = useContext(CalculatorStepsContext);

    const { setDatePresets } = useContext(DatePresetsContext);

    useEffect(() => {
        fetchResources({ steps, setSteps }, setDatePresets);
    }, []);

    const cssStepNames = ['step-1', 'step-2', 'step-3', 'step-4']
    const calculatorInputClasses = ['calculator-inputs', cssStepNames[steps.stepIndex]];



    return (
        <div id="rila-calculator-tool-inputs">
            <div id="rila-calculator-tool">
                <CalculatorStepIndicator steps={stepLabels} />
                <div className={calculatorInputClasses.join(' ')}>
                    <Step1EnterPremiumChooseTerm />
                    {(steps.stepIndex >= CalculatorSteps.STEP_2_SELECT_STRATEGY_TYPES)
                        ? <Step2SelectStrategies />
                        : null}
                    {(steps.stepIndex >= CalculatorSteps.STEP_3_CHOOSE_BUFFERS)
                        ? <Step3ChooseBuffers />
                        : null}
                    {(steps.stepIndex >= CalculatorSteps.STEP_4_CHOOSE_INDICES_ENTER_ALLOCATIONS)
                        ? <Step4ChooseIndicesEnterAllocations />
                        : null}
                </div>

            </div>
        </div>
    )
};
